import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Theme } from '@mui/material'

import {
  requestFailed,
  requestFinished,
  requestStarted,
  setMessage,
  setTheme, setUser,
} from './common.actions'
import { UserLogin } from '@professocialApi/professocial-core-frontend-api/models'
import getAppTheme from '../../defaults/getAppTheme'
import { produce } from 'immer'

import { Message } from '@professocial/professocialTypes/types/messageTypes'
import { ActionCall } from '@professocial/professocialTypes/types'

export interface CommonState {
  theme: Theme
  user?: UserLogin
  message?: Message
  requests: ActionCall[]
}

const INITIAL_STATE: CommonState = {
  theme: getAppTheme(),
  requests: [],
}

const triggerProfessocialMessage = (data: Message) => {
  window.dispatchEvent(new CustomEvent('ProfessocialMessage', { detail: data }))
}

export const CommonReducer = reducerWithInitialState(INITIAL_STATE)
  .case(setTheme, (state: CommonState, theme: Theme) => {
    return ({ ...state, theme })
  })
  .case(setUser, (state: CommonState, user: UserLogin) => {
    return ({ ...state, user })
  })
/**
   * Message Management
   */
  .case(setMessage, (state: CommonState, message: Message) => {
    return produce(state, (draft: any) => {
      triggerProfessocialMessage(message)
      draft.message = message
    })
  })

/**
   *  Requests Management
   */
  .case(requestStarted, (state, action) => {
    return produce(state, (draft) => {
      // filter success state out
      draft.requests.splice(draft.requests.findIndex(request => request.status === 'success'), 1)
      draft.requests.push({ type: action.type, status: 'pending', inProgress: true, error: null, id: action.id, network: action.network })
    })
  })
  .case(requestFinished, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type && request.id === action.id)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'success'
        draft.requests[index].error = null
      }
      setTimeout(() => action.message && triggerProfessocialMessage({
        severity: action.message.severity,
        message: action.message.message,
        eventType: action.message.eventType,
      }))
    })
  })
  .case(requestFailed, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type && request.id === action.id)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'failed'
        draft.requests[index].error = action.error
        draft.requests[index].id = undefined
      }
      setTimeout(() => action.message && triggerProfessocialMessage({
        severity: action.message.severity,
        message: action.message.message,
        eventType: action.message.eventType,
      }))
    })
  })
